// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__O38lU","title":"Intro_title__HkiR7","subTitle":"Intro_subTitle__nXiWQ","buttons":"Intro_buttons__OdwVa","modal":"Intro_modal__RCQbe"};